import { Col, Button, Row, Typography } from 'darrius';

import { useState } from 'react';

import { MdKeyboardArrowDown, MdKeyboardControlKey } from 'react-icons/md';

import styles from './ProfileAbout.module.scss';
interface IProfileAboutProps {
  about: {
    id: string;
    title: string;
    description?: string;
    items?: string[];
  };
}

export const ProfileAbout = ({ about }: IProfileAboutProps) => {
  if (!about) return null;

  const [showMore, setShowMore] = useState(false);

  const SECTION_TITLE = 'Sobre';
  const BUTTON_SEE_MORE_TEXT = 'Ver mais';
  const BUTTON_SEE_LESS_TEXT = 'Ver menos';
  const LONG_TEXT = about.description.length;

  const handleClick = () => {
    setShowMore((prevState) => !prevState);
  };

  const IconButton = showMore ? MdKeyboardControlKey : MdKeyboardArrowDown;

  const isLongText = LONG_TEXT > 155;

  return (
    <section className={styles['profile-about']} id={about.id}>
      <Typography.Subtitle size="l" className={styles.subtitle}>
        {SECTION_TITLE}
      </Typography.Subtitle>
      <Row className={showMore || !isLongText ? '' : styles.hide}>
        <Col>
          <p
            className={`space-bottom about-description ${styles['about-description']}`}
          >
            {about.description}
          </p>
        </Col>
      </Row>
      {isLongText && (
        <Button.Root
          variation="clear"
          className={`see-more-button ${styles['see-more-button']}`}
          onClick={handleClick}
          size="small"
        >
          <IconButton className={styles['see-more-button-icon']} size={25} />
          {showMore ? BUTTON_SEE_LESS_TEXT : BUTTON_SEE_MORE_TEXT}
        </Button.Root>
      )}
    </section>
  );
};
